<template>
  <BLayoutList
    :title="pageTitle"
    :create-route="createRoute"
    :skeleton="isLoadingAsyncData"
  >
    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="publications"
      :list="list"
      :actions="actions"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      :topics="topics"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
      @action:copy="onCopy"
    />
  </BLayoutList>
</template>

<script>
import { lkPublicationPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { PublicationModel as Model } from './Model'
import {
  publicationsStoreModule as StoreModule,
  publicationsMapper as StoreMapper,
} from './store'
import { PUBLICATIONS_ROUTES as ROUTES } from './utils'
import { TABLE_ACTIONS_ADMIN } from '@/views/Publications/table-headers'

import { TopicsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from './components/PublicationsFilter.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewPublicationsList',
  components: {
    BLayoutList,
    BTableCommon,
    ComponentFilter,
  },
  mixins: [
    listMixin,
  ],
  data: () => ({
    topics: null,
  }),
  computed: {
    actions() {
      return !this.$access(Permissions.edit) ? TABLE_ACTIONS_ADMIN : void 0
    },
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
  created() {
    this.getTopicsList()
  },
  methods: {
    ...StoreMapper.mapActions(['copy']),

    async getTopicsList() {
      try {
        const api = new TopicsApi()
        const adapter = new Adapter(api)

        const { data } = await adapter.getAll()
        this.topics = data
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    async onCopy(params, callback) {
      const unwatch = callback?.()

      try {
        const { data } = await this.copy(params)
        const location = {
          name: ROUTES.EDIT,
          params: { id: data.id },
        }
        this.$router.push(location)
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
  },
}
</script>
